module.exports = __webpack_public_path__ + "img/profile-woman-5-min.a3cf536e.jpg";